import { Controller } from "stimulus";
import Rails from "rails-ujs";


export default class extends Controller {

  static targets = ["input"];

  connect() {

  }


  filterProducts(e) {
    var query = this.inputTarget.value;


    document.querySelectorAll(".new-basket-product-preview").forEach((el) => {
    
      if (query.length == 0) {
        el.classList.remove("hidden");
      } else {
        let name = el.dataset.productName.toLowerCase();
        name.includes(query.toLowerCase()) ? el.classList.remove("hidden") : el.classList.add("hidden");
      }

    
    })



  }




}